/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_LabelInputs */

const en_mk_mock_label = /** @type {(inputs: Mk_Mock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product workflow illustration`)
};

const id_mk_mock_label = /** @type {(inputs: Mk_Mock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustrasi alur produk`)
};

/**
* | output |
* | --- |
* | "Product workflow illustration" |
*
* @param {Mk_Mock_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_label = /** @type {((inputs?: Mk_Mock_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_label(inputs)
	return en_mk_mock_label(inputs)
});